export default __webpack_public_path__ + "static/media/gallery_04.fe82597b.jpg";